<template>
    <div>
        <b-modal
            size="xl"
            hide-header
            v-model="showModal"
            @hidden="$_hideModal()"
            @ok="$_ok($event)"
            :ok-title="$t('dataImport.labelStartImport')"
            :cancel-title="$t('btnCancelLabel')"
            :ok-disabled="okDisabled"
            scrollable
        >
            <b-container fluid v-if="record && record.fileName">
                <h2 class="text-left">
                    {{
                        this.$t('dataImport.pageTitleDetailModal', [
                            this.record.format
                        ])
                    }}
                </h2>
                <x-input
                    :text="$t('dataImport.fileName')"
                    :value="record.fileName"
                    id="fileName"
                    name="fileName"
                    plaintext
                >
                </x-input>
                <x-input
                    :text="$t('dataImport.status')"
                    :value="$_status(record.status)"
                    id="status"
                    name="status"
                    plaintext
                >
                </x-input>
                <div v-if="polling" class="mb-3">
                    {{ $t('dataImport.waitingForStatusUpdate') }}
                    <b-spinner
                        id="loadingSpinner"
                        small
                        style="align-self: center"
                        label="Loading"
                        variant="primary"
                        type="grow"
                    />
                </div>
                <table
                    v-if="record.dataImportTables.length > 0"
                    id="geopackagetables"
                    class="table table-striped table-bordered"
                >
                    <caption v-if="false">
                        Geopackage details
                    </caption>
                    <thead>
                        <tr>
                            <th>{{ $t('dataImport.layerName') }}</th>
                            <th>{{ $t('dataImport.tableName') }}</th>
                            <th>{{ $t('dataImport.import') }}</th>
                            <th>{{ $t('dataImport.result') }}</th>
                        </tr>
                    </thead>
                    <tr
                        v-for="(table, index) in record.dataImportTables"
                        :key="index"
                    >
                        <td class="align-middle">
                            <span>{{ table.tableName }}</span>
                        </td>
                        <td class="text-center align-middle">
                            <base-input
                                type="text"
                                :id="`table.importTableName_${index}`"
                                v-model="table.importTableName"
                                @input="$_checkTableName(table.id, $event)"
                                maxlength="58"
                                :extendedStyle="'width: 300px'"
                            >
                            </base-input>
                        </td>
                        <td class="text-center align-middle">
                            <x-checkbox
                                :id="`table.import_${index}`"
                                :name="`table.import_${index}`"
                                :state="null"
                                :plainMode="true"
                                v-model="table.import"
                                @change="$_onImportClick()"
                            >
                            </x-checkbox>
                        </td>
                        <td class="prewrap">{{ table.importResult }}</td>
                    </tr>
                </table>

                <b-card no-body class="mb-1">
                    <b-card-header
                        v-b-toggle="`status`"
                        header-tag="header"
                        class="p-1"
                        role="tab"
                        data-toggle="collapse"
                    >
                        <span>Status</span>
                        <em class="float-right fa"></em>
                    </b-card-header>
                    <b-collapse
                        id="status"
                        accordion="statusaccordion"
                        role="tabpanel"
                    >
                        <b-card-body
                            ><b-table
                                striped
                                hover
                                small
                                outlined
                                bordered
                                v-show="record.dataImportStatuses.length > 0"
                                :tbody-tr-class="$_rowClass"
                                :items="record.dataImportStatuses"
                                :fields="statusFields"
                            >
                            </b-table
                        ></b-card-body>
                    </b-collapse>
                </b-card>
            </b-container>
            <b-spinner
                v-else
                small
                class="mx-2"
                style="align-self: center"
                label="Loading"
            />
        </b-modal>
    </div>
</template>

<script>
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import XInput from '../../components/BaseComponents/x-input.vue';
    import BaseInput from '../../components/BaseComponents/base-input.vue';
    import XCheckbox from '../../components/BaseComponents/x-checkbox.vue';
    import { DATAIMPORT_STATUS } from '../../constants';
    import { dataImportStatus } from '../../services/utilities';
    import { validateSqlName } from '../../services/utilities/validator';

    export default {
        name: 'data-import-detail-modal',

        mixins: [modalMixin],

        components: {
            'x-input': XInput,
            'base-input': BaseInput,
            'x-checkbox': XCheckbox
        },

        props: { id: { type: Number, required: true } },

        data() {
            return {
                showModal: false,
                record: {
                    id: null,
                    dataImportStatuses: [],
                    dataImportTables: []
                },
                showStatus: false,
                statusFields: [
                    {
                        key: 'status',
                        label: this.$t('dataImport.status'),
                        sortable: false,
                        formatter: (value) => {
                            return this.$_status(value);
                        }
                    },
                    {
                        key: 'statusUpdate',
                        label: this.$t('dataImport.statusUpdate'),
                        sortable: false,
                        formatter: (value) => {
                            return new Date(value).toLocaleString(
                                this.$store.state.userInfo.locale
                            );
                        }
                    },
                    {
                        key: 'errorMessage',
                        label: 'Foutmelding',
                        sortable: false
                    }
                ],
                sortBy: '',
                records: [],
                dataImportId: 0,
                previousStatus: '',
                polling: null,
                okDisabled: true,
                invalidTableName: false
            };
        },

        methods: {
            $_showDomainModal() {
                this.showModal = true;
            },
            $_checkTableName(id, name) {
                let invalidMessage;

                // Check valid SQL name
                this.invalidTableName = !validateSqlName(name);
                if (this.invalidTableName) {
                    invalidMessage = this.$t('errorInvalidColumnName');
                }

                // If valid SQL name check for double names
                if (!this.invalidTableName) {
                    this.invalidTableName = this.record.dataImportTables.some(
                        (t) => t.id != id && t.importTableName === name
                    );
                    invalidMessage = this.$t('dataImport.invalidTableName', [name]);
                }

                // In invalid show a toast with message
                if (this.invalidTableName) {
                    const data = {
                        message: invalidMessage,
                        variant: 'danger',
                        autoHideDelay: 3000
                    };
                    this.showToast(data);
                }

                // Determine
                this.$_okDisabled();
            },

            $_status(status) {
                return dataImportStatus(status);
            },
            $_hideModal() {
                this.showModal = false;
                this.$_stopPolling();
                this.$emit('modal-hidden');
            },
            $_okDisabled() {
                // OK button is disabled when no dataImporttable is to be imported.
                // Could not get this to be reactive so we recalculate after each data load
                // and after each checkbox click.
                // button can only be enabled for status ANALYSE_FME and LOADED_FME
                // No ok button when polling for updates
                // No ok button when there are invalid tablenames
                let importTable = false;
                if (
                    !this.polling &&
                    !this.invalidTableName &&
                    [
                        DATAIMPORT_STATUS.ANALYSE_FME,
                        DATAIMPORT_STATUS.LOADED_FME
                    ].includes(this.record.status)
                ) {
                    if (this.record?.dataImportTables) {
                        importTable = this.record.dataImportTables.some(
                            (t) => t.import
                        );
                    }
                }
                this.okDisabled = !importTable;
            },

            // When user clicks on import checkbox, see if OK button should be dis-/enabled.
            $_onImportClick() {
                this.$_okDisabled();
            },
            async $_saveAndImport() {
                try {
                    await this.$_saveDataImportData();
                    await this.$_startDataImport();
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
            },

            // Save dataimport table information to database
            async $_saveDataImportData() {
                await this.$store.dispatch('useApiData', {
                    name: 'UpdateDataImportTables',
                    parameters: { Id: this.id },
                    data: this.record.dataImportTables
                });
            },

            $_startPolling() {
                this.polling = setInterval(() => {
                    this.$_getDataImport();
                }, 2000);
            },
            $_stopPolling() {
                clearInterval(this.polling);
                this.polling = null;
            },

            async $_startDataImport() {
                this.$_startPolling();
                await this.$store.dispatch('useApiData', {
                    name: 'StartDataImport',
                    parameters: { Id: this.id }
                });
                const data = {
                    message: this.$t('dataImport.importStarted'),
                    variant: 'success',
                    autoHideDelay: 3000
                };
                this.showToast(data);
            },

            async $_ok(event) {
                event.preventDefault();
                this.previousStatus = this.record.status;
                await this.$_saveAndImport();
            },

            $_rowClass() {
                return 'tablerow';
            },
            $_startStopPolling(status) {
                // when not already polling start polling when status is:
                // NEW, UPLOAD_FME, START_LOAD_FME
                // when already polling stop polling when status is:
                // ANALYSE_FME, LOADED_FME
                if (!this.polling) {
                    if (
                        [
                            DATAIMPORT_STATUS.NEW,
                            DATAIMPORT_STATUS.UPLOAD_FME,
                            DATAIMPORT_STATUS.START_LOAD_FME
                        ].includes(status)
                    ) {
                        this.$_startPolling();
                    }
                } else {
                    if (
                        [
                            DATAIMPORT_STATUS.ANALYSE_FME,
                            DATAIMPORT_STATUS.LOADED_FME,
                            DATAIMPORT_STATUS.ERROR
                        ].includes(status)
                    ) {
                        const data = {
                            message: this.$t('dataImport.fmeUpdate'),
                            variant: 'success',
                            autoHideDelay: 3000
                        };
                        this.showToast(data);
                        this.$_stopPolling();
                    }
                }
            },

            async $_getDataImport() {
                // Only get data when Id > 0
                // when id = 0 stop polling (in some cases polling continued whith id=0)
                if (this.id === 0) {
                    this.$_stopPolling();
                    return;
                }
                // get all data from the backend
                try {
                    const result = await this.$store.dispatch('useApiData', {
                        name: 'GetDataImport',
                        parameters: { Id: this.id }
                    });
                    // See if polling for updates needs to start or stop.
                    this.$_startStopPolling(result.data.status);
                    this.record = Object.assign([], result.data);

                    // enable/disable ok button
                    this.$_okDisabled();
                } catch (error) {
                    const data = {
                        message: error.message,
                        variant: 'danger',
                        autoHideDelay: 10000
                    };
                    this.showToast(data);
                }
            }
        },
        beforeDestroy() {
            this.$_stopPolling();
        },

        watch: {
            id(newValue) {
                if (newValue && newValue > 0) {
                    this.record = null;
                    this.$_getDataImport();
                    this.$_showDomainModal();
                }
            }
        }
    };
</script>

